export const siteConfig = {
  name: 'Rays Sports Network',
  tagline: 'Professional sports training platform for coaches, athletes, and organizations worldwide.',
  logo: {
    white: '/images/Rays Logo white.png',
    black: '/images/Rays Logo black.png',
  },
  copyright: 'Rays Sports Network. All Rights Reserved.',
} as const;
